<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="_pageSetting.primary"
    :secondary="_pageSetting.secondary"
    titleKey="name"
    :isMultiSelect="true"
    :showExpand="false"
    :showFields="showFields"
    :staticModelData="staticModelData"
  >
  </WsRead>
</template>

<script>
import model from "@/models/role";
export default {
  data(){
    return {
      modelName: model.modelName,
      label: model.label,
      localeMode: true,
      fields: model.fields,
      showFields: ["name"],
      staticModelData: (modelData, fields) => {
        //從這裡抓 modelData.scopes,再跑for迴圈和if判斷把一個個資料丟給要顯示的欄位
        model.scopeFields.forEach((scopeItem) => {
          if (fields[scopeItem].items.length) {
            fields[scopeItem].items.forEach((valueItem) => {
              let result = true;
              if (valueItem.value) {
                valueItem.value.forEach((item) => {
                  if (result) {
                    result = modelData.scopes.includes(item);
                  }
                });
                if (result) {
                  modelData[scopeItem] = [
                    ...(modelData[scopeItem] || []),
                    ...valueItem.value,
                  ];
                }
              }
            });
          }
        });
      },
    }
  },
  computed: {
    _pageSetting() {
      return {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "角色資訊",
                fields: ["locales", "sequence"],
              },
              {
                title: "角色權限",
                fields: model.scopeFields,
              },
            ],
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "客製角色",
                type: "switch",
                fields: ["is_default", "factories"],
              },
            ],
          },
          {
            type: "activeSwitch",
            title: "顯示設定",
            remark: "隱藏的內容將不會顯示於前端",
            field: "is_active",
          },
          {
            type: "infoCard",
            floors: [
              {
                title: "建立資訊",
                fields: ["created_admin", "created_at"],
              },
            ],
          },
          {
            type: "infoCard",
            floors: [
              {
                title: "編輯資訊",
                fields: ["updated_admin", "updated_at"],
              },
            ],
          },
        ],
      };
    }
  }
};
</script>